import { CoreInputViewNew, CoreTextView, CoreLayoutView, ORIENTATION_ENUM } from '@core/widgets';
import React, { useId } from 'react';
import { SemanticColor, semanticColors } from '../../../theme/colors';
import { TextStyle } from '../../../types/styles';
import styles from '../Calculator.module.css';
import { getClearValue, getFormattedValue } from '../utils/format/format';
import { THandleUpdateValue } from '../utils/types';

type TCalculatorInputProps = {
    label?: string;
    name: string;
    value: string;
    isError?: boolean;
    isFrom?: boolean;
    handleUpdateValue: THandleUpdateValue;
    fontSize: string;
    subRow: React.ReactNode;
    tabIndex?: number;
    parentStyleNames?: string[];
};

const CalculatorInput = React.memo(
    ({ label, isError, value, handleUpdateValue, tabIndex, subRow, name, isFrom, fontSize, parentStyleNames }: TCalculatorInputProps) => {
        const inputId = useId();

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const clearValue = getClearValue(e?.target.value, value);
            handleUpdateValue(clearValue, e.target.name, isFrom);
        };
        return (
            <CoreLayoutView
                styleName="calculatorInputColumn"
                parentStyleNames={parentStyleNames}
                styleProps={{ orientation: ORIENTATION_ENUM.VERTICAL, lineX: 'center' }}
            >
                <CoreTextView
                    text={label}
                    styleName="calculatorInputTitle"
                    parentStyleNames={parentStyleNames}
                    styleProps={{
                        ...TextStyle.main,
                        main: semanticColors[SemanticColor.TextPrimary],
                        margin: { bottom: 4 },
                    }}
                />
                <div className={styles.calculatorInputWrapper}>
                    <CoreInputViewNew
                        styleName="calculatorInputAmount"
                        parentStyleNames={parentStyleNames}
                        styleProps={{
                            variant: 'filled',
                            fillContainer: true,
                            surfaceContainerHighest: semanticColors[SemanticColor.BgSecondary],
                            inputBorderRadius: 0,
                            font: TextStyle.display2.font,
                            outline: 'transparent',
                            onSurface: semanticColors[SemanticColor.TextPrimary],
                            padding: { top: 0, right: 0, bottom: 0, left: 0 },
                            textAlign: 'center',
                            height: 40,
                            error: { main: semanticColors[SemanticColor.IconError], onSurface: semanticColors[SemanticColor.TextError] },
                            fontStyle: { ...TextStyle.display2.fontStyle, fontSize: parseInt(fontSize) || 32 },
                        }}
                        dataTest={`calculator_input_${isFrom ?? ''}`}
                        id={inputId}
                        name={name}
                        value={getFormattedValue(value)}
                        autoComplete="off"
                        onChange={handleChange}
                        type="text"
                        inputMode="decimal"
                        tabIndex={tabIndex}
                        isError={isError}
                    />
                </div>
                {subRow}
            </CoreLayoutView>
        );
    },
);
export { CalculatorInput };
